/**
 * Created by zuozhuo on 2018/1/26.
 */
export const FRONT_PREFIX = "/front";
export const URL_INDEX = FRONT_PREFIX + "/home";
export const URL_LOGIN = FRONT_PREFIX + "/login";
export const url_perfect_info = FRONT_PREFIX + "/login/perfect_info";
export const APP_VERSION = "3.2.1";
export const GENDER_VALS = {
  UNKNOWN: 0,
  MALE: 1,
  FEMALE: 2
};
/*
| 值 | 说明 |
| :--- | :--- |
| 0 | 正常进入首页 |
| 1 | 弹出用户协议 |
| 2 | 根据身份进入工人-完善信息\(3/3\) 或 工长-完善信息\(2/2\) |
| 3 | 根据身份进入工人-完善信息\(2/3\) 或 工长-完善信息\(1/2\) |
| 4 | 进入工人-完善信息\(1/3\) |
| 5 | 进入身份选择 |
| 6 | 绑定手机 |
*/
export const USER_REG_STEPS = {
  HOME: 0,
  TERM: 1,
  COMPLETE3: 2,
  COMPLETE2: 3,
  COMPLETE1: 4,
  ROLE_CHOOSE: 5,
  PHONE_BIND: 6
};
export const HTTP_CODE_SUCCESS = 200;
export const HTTP_CODE_WX_KEY_EXPIRED = 4000;
export const HTTP_CODE_NEED_AUTH_ARRAY = [1005, 401];
export const HTTP_CODE_COIN_NOT_ENOUGH = 1020;
export const HTTP_CODE_COIN_FAIL = 12011;
export const HTTP_CODE_NO_SUBSCRIBED = 5000;
export const BLANK_IMAGE_BASE64_URL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
export const ERROR_CODES = {
  "1000": "返回正常",
  "1001": "非法请求",
  "1002": "签名验证失败",
  "1003": "参数缺失",
  "1004": "版本错误",
  "1005": "用户登录状态验证失败",
  "1006": "服务器出错",
  "1007": "支付宝相关错误",

  "2001": "手机号或密码错误",
  "2002": "今日发送手机验证码次数过多",
  "2003": "验证码错误",
  "2004": "验证码已过期",
  "2005": "账号不存在",
  "2006": "密码错误",

  "3000": "手机号已经注册",
  "3001": "手机号格式错误",

  "4000": "微信授权失败"
};

/**
 * 优惠券适用范围
 */
export const COUPON_APPLICATION_SCOPES = {
  "": "全场通用",
  recharge: "充值",
  lesson: "购买课程",
  article: "购买咨询",
  sub: "购买订阅",
  vod: "直播点播",
  qa: "问答提问",
  qa_look: "问答围观",
  qrcode: "扫码支付",
  mall: "商城订单",
  sign: "签到"
};

export const ARTICLE_TYPES = {
  NEI_CAN: "7", //'法商内参',
  BAO_DIAN: "8", //'法商宝典',
  MO_BAN: "10", //'法商模板',
  TOU_TIAO: "13", //'法商头条',
  DA_DAN: "18" //'法商大单'
};

/**
 * 评论类型
 * 1 文章评论
 * 2 订阅评论 (订阅文章评论)
 * 3 话题评论
 * 4 回放评论
 * 5 课程评论 (课时评论)
 */
export const COMMENT_TYPES = {
  // 文章评论
  ARTICAL_COMMENT: "1",
  // 订阅专栏内容页评论
  SUB_COMMENT: "2",
  // QA_COMMENT: "3",
  // 话题页评论
  GROUP_POST_COMMENT: "3",
  // 回放页评论
  PLAYBACK_COMMENT: "4",

  // 课时内容页评论
  LESSON_COMMENT: "5",
  // 课程首页-精选评论
  LESSON_INDEX_COMMENT: "6",
  // 订阅专栏首页-精选评论
  // 咨询师评论
  SUB_INDEX_COMMENT: "7",
  // 读书会-精选评论
  READ_MEETING_COMMENT: "8",
  COUNSELOR_COMMENT: "9"
};

/**
 * 点赞动作
 * 1 点赞
 * 2 取消点赞
 */
export const LIKE_ACTIONS = {
  like: 1,
  unlike: 2
};

export const PURCHASE_METHODS = {
  wechat: "wechat", // 微信支付
  fo_coin: "fo_coin" // 内购
};
/*
- 使用红包
- 赠送好友
- 邀请人奖励
 */
export const PURCHASE_TYPES = {
  vod: "vod", // 直播点播, 微信支付+内购
  sub: "sub", // 订阅, 微信支付+内购
  lesson: "lesson", // 课程, 微信支付+内购

  wxa_lesson: "wxa_lesson", // 小程序购买的课程, 微信支付
  wxa_group_buy_lesson: "wxa_group_buy_lesson", // 小程序的团购课程, 微信支付

  qa: "qa", // 问答围观, 内购
  mall: "mall", // 商城, 内购
  recharge: "recharge", // 法商充值, 微信支付
  sign: "sign", // 签到, 内购
  offline: "offline" // 线下产品购买, 微信支付
};

export const INVITE_MEMBER_ID = "member_id";

export const PAYMENT_PLATFORMS = {
  other: "0",
  apple: "1",
  android: "2",
  open_wx: "3",
  wxa: "4"
};
export const PAYMENT_TYPES = {
  apple: "1",
  alipay: "2",
  app_wx: "3",
  open_wx: "4",
  wxa: "5",
  coin: "6"
};
export const PAYMENT_TARGET_TYPES = {
  recharge: "recharge",
  lesson: "lesson",
  article: "article",
  sub: "sub",
  vod: "vod", // 购买直播点播
  qa: "qa",
  qa_ask: "qa_ask",
  qa_reask: "qa_reask",
  qa_look: "qa_look",
  sign: "sign",
  mall: "mall",
  consult: "consult"
};

export const ORDER_CONFIRM_SOURCE = {
  cart: "1",
  instanly_buy: "2"
};

export const GOODS_CHANNEL_TYPES = {
  online: "1",
  offline: "2",
  column: "3"
};

export const MLINK_TYPES = {
  site: 1,
  artical: 2,
  sub: 3,
  qa: 4,
  live: 5,
  vod: 6,
  lesson: 7,
  sign: 8, // 签到首页
  redbag: 9, // 红包首页
  sub_exercise_result: 10, // 订阅文章答题解析
  group_post: 11, // 学习小组话题详情
  lesson_exercise_result: 12, // 课程课时答题解析
  home: 13,
  wxLogin: 14,
  appLogin: 15,
  lesson_exercise: 16, // 课程答题
  lesson_study_group: 17, // 课程学习小组
  my_point: 18, // 我的积分
  my_coins: 19, // 我的法商值
  mall: 24 // 商城
};

export const WEIXIN_PAY_PAGES_TYPE = {
  columnDetail: "columnDetail",
  liveDetail: "liveDetail",
  recharge: "recharge",
  mall: "mall",
  order: "order",
  lesson: "lesson",
  qa: "qa",
  qaList: "qaList",
  orderList: "orderList",
  qaQuestion: "qaQuestion",
  qaQuestionDetail: "qaQuestionDetail",
  appointment: "appointment",
  mineAppointment: "mineAppointment",
  mineAppointmentDetail: "mineAppointmentDetail",
  vodDetail: "vodDetail",
  evaluation: "evaluation"
};

export const DELIVERY_FEE = 0;
export const FREE_DELIVERY_FEE_THRESHOLD = 588;
export const DEFAULT_SHARE_IMAGE =
  "https://image.lxeap.cn/images/lx_logo.png_120";
export const LIVE_STATE_TYPES = {
  DELETED: "0",
  NOT_START: "1",
  STREAMING: "2",
  END: "3"
};
// 会员等级，0无等级，1V会员，2R会员，3X会员
export const MEMBER_VIP_LEVEL = {
  NULL: "0",
  V: "1",
  R: "2",
  X: "3"
};

export const MEMBER_VIP_LEVEL_LABEL = {
  "1": "v",
  "2": "r",
  "3": "x"
};

export const URL_HASH_KEYS = {
  HTML_CACHE_HASH: "_t_",
  JS_SDK_HASH: "_jssdk_hash"
};

export const WeinreServerURL = "https://debug-proxy.foschool.cn/weinre/";
export const CUSTOMER_SERVICE_TEL = "0731-84162901";
export const VOD_RECORD_TYPE = {
  SPEAKER: "2",
  INTERACTIVE: "1"
};

export const APP_NAV_TITLE = "立心心理";
export const CUSTOMER_PHONE_TEL = "0731-84162901";
export const CUSTOMER_SERVICE_WECHAT = "15111100849";
export const REGEX_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const REWARD_TYPES = {
  NULL_GOOD: 0, // 空奖
  FACT_GOOD: 1, // '实物奖'
  COUPON_GOOD: 2, // '红包'
  FO_GOOD: 3, // '法商值'
  FO_POINT_GOOD: 4 // '立心积分'
};

export const ONLINE_SERVICE_URL = "https://foschool.mikecrm.com/tXQ177P";

export const MEDIA_PLAYER_TARGET_TYPES = {
  column: "column",
  lesson: "lesson",
  article: "article",
  qa: "qa",
  live: "live",
  vod: "vod"
};

export const CONSULT_CHANNELS = {
  text: 1,
  voice: 2,
  video: 3,
  meet: 4
};

export const CONSULT_CHANNEL_NAMES = {
  [CONSULT_CHANNELS.video]: "视频咨询",
  [CONSULT_CHANNELS.voice]: "语音咨询",
  [CONSULT_CHANNELS.meet]: "面对面咨询",
  [CONSULT_CHANNELS.text]: "文字咨询"
};

// 性别
export const GENDER_MAP = {
  "0": "未填写",
  "1": "男",
  "2": "女",
  "3": "保密"
};

// 学历
export const EDUCATION_MAP = {
  "0": "其他",
  "1": "专科",
  "2": "本科",
  "3": "研究生",
  "4": "博士",
  "5": "博士后"
};

// 咨询状态
export const APPOINTMENT_STATES = {
  all: undefined, // 全部
  unpaid: 1, // 待支付
  paid: 2, // 已支付
  completed: 3, // 已完成
  cancelled: 4 // 已取消
};

export const APPOINTMENT_STATE_NAMES = {
  [APPOINTMENT_STATES.unpaid]: "待处理",
  [APPOINTMENT_STATES.paid]: "已完成",
  [APPOINTMENT_STATES.completed]: "已完成",
  [APPOINTMENT_STATES.cancelled]: "已取消"
};



// WEBPACK FOOTER //
// ./src/consts/consts.js